import React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import Signin from "../Dashboard/Auth/signin/signin";
import { useAuth } from "../Dashboard/Auth/AuthContext";
import PageNotFound from "../PageNotFound/PageNotFound";
import Settings from "../Dashboard/pages/settings/settings";
import Projects from "../Dashboard/pages/projects/Projects";
import Loading from "../MainWebsite/Components/Loading/Loading";
import ProjectVideos from "../Dashboard/pages/ProjectVideos/ProjectVideos";
import Services from "../Dashboard/pages/Services/Services";
import BusinessServices from "../Dashboard/pages/BusinessServices/BusinessServices";
import About from "../Dashboard/pages/AboutUs/About";
import OurImpacts from "../Dashboard/pages/OurImpact/OurImpact";
import ProjectListContents from "../Dashboard/pages/ProjectListContent/ProjectListContent";
import ProjectImages from "../Dashboard/pages/ProjectImages/ProjectImages";
function DashboardRoutes() {
  const { isLoggedin, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return <Loading />;
  }
  if (!isLoggedin && location.pathname !== "/dashboard/signin") {
    return <Navigate to="/dashboard/signin" replace />;
  }

  if (isLoggedin && location.pathname === "/dashboard") {
    return <Navigate to="/dashboard/projects" replace />;
  }

  return (
    <Routes>
      {isLoggedin ? (
        <>
          {/* <Route  element={<Index />} /> */}

          <Route path="projects" index element={<Projects />} />
          <Route path="services" element={<Services />} />
          <Route path="about-dashboard" element={<About />} />
          <Route path="business-services" element={<BusinessServices />} />
          <Route path="ourimpact-dashboard" element={<OurImpacts />} />
          <Route path="project-images" element={<ProjectImages />} />

          <Route path="settings" element={<Settings />} />
          <Route
            path="project-list-content"
            element={<ProjectListContents />}
          />
          <Route path="project-videos" element={<ProjectVideos />} />
        </>
      ) : (
        // If the user is not logged in, redirect to the sign-in page
        <Route path="*" element={<Navigate to="signin" />} />
      )}
      <Route path="signin" element={<Signin />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}

export default DashboardRoutes;
